import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import OnboardingService, { CHAVES_ONBOARDING } from '../api/OnboardingService';

export default function useOnboarding() {
  // O tour é fechado localmente antes do PUT responder; o `completeOnboarding`
  // no service invalida a chave e reconcilia com o servidor.
  const [dispensado, setDispensado] = useState<boolean>(false);

  const query = useQuery({
    queryKey: CHAVES_ONBOARDING.status,
    queryFn: async () => (await OnboardingService.getOnboardingStatus()).data?.onboardingCompleted ?? false,
  });

  const onboardingCompleted = query.data ?? false;

  const completeTour = async () => {
    setDispensado(true);
    try {
      await OnboardingService.completeOnboarding();
    } catch (err) {
      console.error('Erro ao marcar onboarding como concluído:', err);
    }
  };

  return {
    // Em caso de erro o tour não aparece (comportamento anterior): `isSuccess`.
    showTour: query.isSuccess && !onboardingCompleted && !dispensado,
    loading: query.isPending,
    onboardingCompleted: onboardingCompleted || dispensado,
    completeTour,
  };
}
